import React from 'react';

const HowToPlay = () => {
    return (
        <div className="rootAbout">
            <p>
                <b>1.</b> To Play any of the game this app provides you just need to sign in using your facebook or google account and then you will see different cards of sports , you jsut need to select one.
            <br /><br />
                <b>2.</b >  After selecting a sport you will see list of upcoming matches there with details of player or teams. Just select one and then you will be redirected on bet page where you will see details abut each team like their rating , betting price , name etc.
            <br /><br />
                    <b>3.</b> Here you can bet on any team you want by clicking it and entering the amount of money there and you will also see how much you will get if you win. After that you will be redicted to participation page where you confirm you enrollment.
            <br /><br />
                    <b>4.</b>After enrolling you can see all your progress from home tab by selecting a match from my games tab.
        </p>
        </div>
            );
        }
        
export default HowToPlay;